import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, OnChanges } from '@angular/core'
import { Store } from '@ngrx/store'
import { VendorConversationTeamV1 } from '../../../api/api/models/vendor-conversation-team-v1'

import * as fromTeam from '../../../shared/team'
import { AppState } from '../../../store'
import { MY_WORK_ID } from '../../team/store/reducers/conversation-team.reducer'

@Component({
  selector: 'app-team-list',
  templateUrl: './team-chip-list.component.html',
  styleUrls: ['./team-chip-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamChipListComponent implements OnChanges{

  @Input() teams: VendorConversationTeamV1[]
  @Input() selectedTeamId: number
  @Output() select = new EventEmitter<VendorConversationTeamV1>()

  constructor(private store: Store<AppState>) {
  }

  ngOnChanges() {
    this.focusTextArea()
  }

  onTeamSelected(team: VendorConversationTeamV1) {
    this.store.dispatch(new fromTeam.NewMessage({vendorTeamId: team.id, newMessage: false}))
    this.select.emit(team)
  }

  openList(event) {
    event.stopPropagation()
  }

  getTeam() {
    return this.teams.find(t => t.id === this.selectedTeamId)
  }

  isMyWork() {
    return this.selectedTeamId === MY_WORK_ID
  }

  private focusTextArea() {
    const element = document.getElementById('text-message-response')
    if (element != null) {
      element.focus()
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/navbar/team-chip-list/team-chip-list.component.ts